import { render, staticRenderFns } from "./dashboardAdmin.vue?vue&type=template&id=487c8ff7"
import script from "./dashboardAdmin.vue?vue&type=script&lang=js"
export * from "./dashboardAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports